export default __webpack_public_path__ + "static/media/img102.5b5b2abd.png";